
import {
  Component, Emit, Prop, Vue,
} from 'nuxt-property-decorator'
import type { RichTextElement } from 'fsxa-api'
import { globalLabel } from '../../shared/general/services/StoreService'
import BaseIcon from '../base/BaseIcon.vue'
import GlobalLabelWrapper from '../GlobalLabelWrapper.vue'
import GptMessage from './GptMessage.vue'
import type { TGptMessage } from '../../shared/general/types/GptHub'

@Component({
  name: 'GptLog',
  components: {
    BaseIcon,
    GlobalLabelWrapper,
    GptMessage,
  },
})
export default class GptLog extends Vue {
  @Prop({ required: true }) log! : TGptMessage[]

  @Prop({ default: false }) failed! : boolean

  $refs! : {
    container ?: HTMLElement
  }

  updated () {
    const container = this.$refs.container!
    container.scrollTop = container.scrollHeight
  }

  @Emit('resend')
  private resend () : void {}

  private get gptHubCapacityErrorLabel () : string | RichTextElement[] {
    return globalLabel('gpt_hub_capacity_error_label')
  }
}
